import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { trigger, style, animate, transition } from "@angular/animations";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import {PlatformLocation} from '@angular/common';

declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-case-practice-cooperation-list",
  animations: [
    trigger("wrapAnimation", [
      transition("* => void", [
        style({
          opacity: 1,
        }),
        animate(
          "200ms",
          style({
            opacity: 0,
          })
        ),
      ]),
    ]),
  ],
  templateUrl: "./case-practice-cooperation-list.component.html",
  styleUrls: [
    "./case-practice-cooperation-list.component.css",
  ],
})
export class CasePracticeCooperationListComponent
  implements OnInit, AfterViewInit {
  @Input() practiceList: any;
  @Input() practiceId: any;
  @Input() learningPathId: any;
  @Input() type: string;

  @Output() onGoToNextStep = new EventEmitter<any>();
  @Output() onSetPracticeIndex = new EventEmitter<any>();

  finished: boolean;
  learningPath: any;
  finishStatus: boolean;
  learningTour: boolean;
  chuanjie: any;

  //进入新能力考核标识
  version: number = 0;
  //学习 metaId
  learningPathMetaId: number = 0;
  //学习meta 列表
  learningPathMetas: any;
  goPostSurveyFlag: boolean;
  isShowQuestionnaire: boolean = false;
  questionnaireInfo: any = null;
  learningPathSubItems: any;
  isOpenClass: number = 0;
  approachTheme: any = {};
  currentIndex: number = 0;
  isShowApproach: boolean = false;
  isCustomLock: boolean = false;

  projectId: string;
  lock: boolean = false;
  isShowToast: boolean = false;
  promptText: string;
  isTencent = false; // 是否腾讯对接
  get showGoToSurveyBtn():boolean{
    return this.practiceList.every(item=>{
      return item.status === 2;
    })
  }
  constructor(
    private commonService: CommonService,
    private apiService: ApiService,
    private platformLocation: PlatformLocation,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    // ---Stephen add 2025-03-07---
    // 添加是否腾讯对接的判断
    this.isTencent = this.commonService.checkAndSetModuleId();
    console.log(this.isTencent, '🐀🐀🐀🐀🐀🐀');
    // -------------------------------------------------------------------
    let temp = true;
    let that = this;
    this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
    localStorage.setItem("moduleId","3");
    localStorage.removeItem('sh');
    this.projectId = localStorage.getItem("projectId")
    let projectmsg = JSON.parse(localStorage.getItem('projectmsg'))
    if(this.projectId && projectmsg){
      projectmsg.map(item=>{
        if(item.type == 4 && item.lockType == 1){
          this.lock = item.lock;
          this.promptText = `能力考核将于${item.promptTime}开放。`
        }
      })

    }
    //loadconfig
    this.apiService
      .loadConfig("./assets/config/practiceList.json")
      .subscribe((result) => {
        this.practiceList.forEach(function (item, index) {
          if (result[item.title] != null) {
            item["extends"] = result[item.title];
          }
        });
      });

    this.apiService
      .ajax({
        type: "get",
        url: "/api/concatenation/" + this.learningPathId,
        data: {
          learningPathId: this.learningPathId,
        },
      })
      .subscribe((comment) => {
        comment.forEach(function (item, index) {
          if (item.title == "情景模拟") {
            that.chuanjie = item.comment;
          }
        });
      });

    this.apiService
      .ajax({
        type: "get",
        url: "/sr/learningtour",
      })
      .subscribe((result) => {
        this.learningPathMetas = result.learning_path_metas;
        this.learningTour =
          result.pre_survey_meta_ids.length > 0;
        this.apiService
          .ajax({
            type: "get",
            url: "/sr/onceino/155",
            data: {},
          })
          .subscribe((result) => {
            this.finishStatus = result == 1;
            for (var i = 0; i <= this.practiceList.length - 1; i++) {
              if (this.practiceList[i].status != 2) {
                temp = false;
              }
            }
            this.finished = temp;

            this.getLearningPathMetaId();
            // this.getUserQuestionnaireInfo(this.learningPathMetaId).then(result=>{
            //   this.questionnaireInfo = result;
            //   this.isShowQuestionnaire = this.questionnaireInfo && (this.questionnaireInfo.length ===0 || (this.questionnaireInfo.length > 0 && this.questionnaireInfo.isShow !== 1)) && this.learningPathSubItems.filter(d=>d.type === 3)[0].progress ===100 && this.learningPathSubItems.filter(d=>d.type === 4)[0].progress!==100 ? true : false;
            // });

            setTimeout(() => {
              if (this.finished) {
                //新能力考核 version == 1 时,有能力考核,出现考核按钮,完成按钮不出现
                if (this.version == 1) {
                  $("#surveyBtn").fadeIn(200);
                } else {
                  $("#nextWrap").show().animate({ bottom: 0 });
                }
              }
            }, 1000);
          });
      });
  }



  //获取进度
  getProgress(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds='+String(learningPathMetaId),
    }).toPromise();
  }

  //获取用户学习 metaid and version
  getLearningPathMetaId() {
    var that = this;
    this.learningPathMetas.forEach(function (item, i) {
      if (item.learningPathId == that.learningPathId) {
        if(that.type){
          $('#learningPathMetaIdContainer').val(item.id)
        }
        that.learningPathMetaId = item.id;
        that.getOrCreateLearningPath(String(that.learningPathMetaId)).then(result=>{
          that.learningPath = result;
          that.commonService.setCustomLockDate(that.learningPath,Date());
          that.learningPathSubItems = that.learningPath.subItems;
        }).then(()=>{
          return that.getUserQuestionnaireInfo(that.learningPathMetaId).then(result=>{
            return that.questionnaireInfo = result;
          });
        }).then(()=>{
          return that.getProgress(that.learningPathMetaId).then(result=>{
            //向LMS传递进度
            if(localStorage.getItem("source_env") === "LMS_SCORM"){
              that.commonService.sendDataMessage('type','LMS_LEARN_PROGRESS',result[0].progressList[0].progress,"data");
            }
            return that.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'] ;
          })
        }).then(()=>{
          that.approachTheme.colorSystem = 'dark';
          that.approachTheme.label = ['能力诊断','课程学习','情景模拟','能力考核'];
          that.approachTheme.currentIndex = that.currentIndex -2;
          that.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
          that.approachTheme.btnTxt = '开启能力考核';
          that.isShowQuestionnaire = that.questionnaireInfo && that.questionnaireInfo.length === 0 && that.learningPathSubItems.filter(d => d.type === 3)[0].progress === 100 && that.learningPathSubItems.filter(d => d.type === 4)[0].progress !== 100;
        }).then(()=>{
          //增加学习断点
          that.commonService.addUserBreakPoint({'learningPathMetasId':Number(that.learningPathMetaId),'moduleId':3,'breakpointUrl':that.platformLocation['location']['href'],'projectId':localStorage.getItem("projectId")?localStorage.getItem("projectId") : null}).then();
          that.isCustomLock = that.learningPathSubItems[3].isLock;
          that.isShowApproach = true;
        });

        // that.apiService
        //   .getOrCreateLearningPath(String(that.learningPathMetaId))
        //   .subscribe((result) => {
        //     that.learningPath = result;
        //     that.learningPathSubItems = result.subItems;
        //     if (result.lock !== 3) {
        //       that.goPostSurveyFlag = true;
        //     } else {
        //       that.goPostSurveyFlag = false;
        //     }
        //   });
        if (item.version) {
          that.version = item.version;
        }
      }
    });
  }

  getOrCreateLearningPath(learningPathMetaId){
    return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
  }

  ngAfterViewInit() {
    this.commonService.initPage({
      backgroundColor: "white",
    });
  }

  goToNextStep(i) {
    $('#exerciseMetaId').val(this.practiceList[0].exerciseMetaId)
    if(this.practiceList[0].status!==2){
      const exerciseMetaId=$('#exerciseMetaId').val()
      this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:1,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
        console.log(result)
      })
      console.log(exerciseMetaId)
      this.commonService.sendPostMessage(0,'isPractice' +'Complete')
    }
    // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟'+(i+1)}).then();
    this.onSetPracticeIndex.emit(i);
    if (this.practiceList[i].status == 2) {
      let link = [
        "case-practice-report-new",
        this.practiceId,
        this.practiceList[i].id,
        this.learningPathId,
      ];
      if(this.type){
        this.router.navigate(link,{queryParams:{type:'huatek'}});
      }else{
          this.router.navigate(link);
      }
    } else {
      this.apiService
        .ajax({
          type: "get",
          url: "/api/pnoStorePoint/" + this.practiceList[i].id,
        })
        .subscribe((result) => {
          if (result.status == 0) {
            this.onGoToNextStep.emit(1);
          } else if (result.status == 5) {
            this.onGoToNextStep.emit(2);
          } else if (result.status == 10) {
            this.onGoToNextStep.emit(3);
          } else if (result.status == 15) {
            let link = [
              "case-practice-authorization-main",
              this.learningPathId,
              this.practiceId,
              this.practiceList[i].id,
            ];
            if(this.type){
              this.router.navigate(link,{queryParams:{type:'huatek'}});
            }else{
                this.router.navigate(link);
            }
          }
        });
    }
  }

  goToPostSurvey() {
    if( this.type === 'huatek'){
      this.commonService.sendPostMessage(1,'goPostSurvey')
      return
    }else{
      if(this.lock){
        this.showToast();
        return
      }

      this.apiService
      .ajax({
        type: "GET",
        url:
          "/sr/exposeoutapi/setAbilitySession/" +
          this.learningPathMetaId +
          "/4",
      })
      .subscribe((result) => {});
      let link = ["ability-survey", this.learningPathMetaId, 2];
      // let link = ["survey", this.learningPathId, 9, 1];
      // //新能力考核
      // if (this.version == 1) {
      //   link = ["ability-survey", this.learningPathMetaId, 2];
      // }
      this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'情景模拟','btnName':this.approachTheme.btnTxt,'userId':localStorage.getItem("userId")}).then();
      this.router.navigate(link);
    }

  }

  showToast(){
    this.isShowToast = true;
    setTimeout(()=>{
      this.isShowToast = false;
    },2000);
  }

  finish() {
    if (this.finishStatus) {
      return;
    } else {
      //if(this.learningTour){

      this.apiService
        .ajax({
          type: "post",
          url: "/sr/onceino/155",
          data: {},
        })
        .subscribe();

      //}
      let link = ["learning-map"];
      this.router.navigate(link);
    }
  }

  close() {
    this.apiService
      .ajax({
        type: "get",
        url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
      })
      .subscribe((result) => {
        // 只在learningTour里出现，当完成能力是退出进入map
        if ((this.finishStatus || !this.finished) && this.learningTour) {
          let link = ["learning-map", 3];
          this.router.navigate(link);
        } else if (!this.finishStatus && this.finished && this.learningTour) {
          this.apiService
            .ajax({
              type: "post",
              url: "/sr/onceino/155",
              data: {},
            })
            .subscribe(
              (result) => {
                let link = ["learning-map", 3];
                this.router.navigate(link);
              },
              (error) => {
                let link = ["error"];
                this.router.navigate(link);
              }
            );
        } else {
          let link = ["learning-path", result.data];
          this.router.navigate(link);
        }
      });
  }

  closeQuestionnaire(){
    this.isShowQuestionnaire = false;
  }

  //查询用户相应能力满意度
  getUserQuestionnaireInfo(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
    }).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-list/case-practice-cooperation-list.component.ts